import InfoEmployeePanel from "./infoEmployeePanel.container";

export default InfoEmployeePanel;